import React from 'react';
import { useIntl } from 'react-intl';
import { Autocomplete, TextField } from '@mui/material';
import { StatusMessage } from './StatusMessage';

const getOptionLabel = (unit) => {
  if (!unit.esn || unit.esn === unit.label) return unit.label;
  return `${unit.label} (${unit.esn})`;
};

const isSameUnit = (option, value) => option.cameraDeviceId === value.cameraDeviceId;

// Server-driven search: MUI does not filter, the typed text goes to the API (debounced).
export const UnitSelect = ({ unit, unitList, onSearch, onPick }) => {
  const { formatMessage } = useIntl();
  const { units, isFetching, isError, hasNextPage, isFetchingNextPage, fetchNextPage, refetch } = unitList;

  const handleInput = (event, text, reason) => {
    if (reason === 'input') onSearch(text);
  };

  // A unit handed in from outside may not be on the loaded page; keep it as an option.
  let options = units;
  if (unit && !units.some((item) => isSameUnit(item, unit))) options = [unit, ...units];

  let feedback = null;
  if (isError) feedback = <StatusMessage id="requestVideo_unit_error" tone="error" onRetry={refetch} />;

  return (
    <div className="request-video-unit">
      <Autocomplete
        value={unit}
        options={options}
        loading={isFetching}
        filterOptions={(options) => options}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isSameUnit}
        onChange={(event, next) => next && onPick(next)}
        onInputChange={handleInput}
        noOptionsText={formatMessage({ id: 'requestVideo_unit_none' })}
        loadingText={formatMessage({ id: 'requestVideo_unit_loading' })}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={formatMessage({ id: 'requestVideo_unit_label' })}
            placeholder={formatMessage({ id: 'requestVideo_unit_placeholder' })}
          />
        )}
      />
      {hasNextPage && (
        <button
          type="button"
          className="request-video-link-button"
          disabled={isFetchingNextPage}
          onClick={fetchNextPage}
        >
          {formatMessage({ id: 'requestVideo_unit_loadMore' })}
        </button>
      )}
      {feedback}
    </div>
  );
};
